<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M21.5 18.8571V20H2.5V18.8571H21.5ZM8.31176 9.69143L13.0059 13.1543L19.2647 6V8.60571H20.3824V4H15.8671V5.14286H18.5159L12.8494 11.6114L8.23353 8.21714L3.34941 12.7429L4.09824 13.5886L8.31176 9.69143Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
